import React from 'react';
import styles from './circleTick.module.sass';
import applyWrappers from 'wrappers/ComponentWrapper';

const Close = (props) => {
    const skin = props.skinGuide.globalProfiles.palette
    const color = props.backgroundColor || skin.white;

    return (
        <div styleName="main-component">
            <svg  viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8.5" cy="8" r="7" stroke="#EE7748" stroke-width="2" />
                <path d="M4.57715 8.83282L6.61551 10.8712L12.0512 5.43555" stroke="#EE7748" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    );
}



export default applyWrappers(Close, styles);
